/* eslint-disable */
export default {
  _blow: 'blow',
  _bat: 'bat',
  _cut: 'cut',
  _scary_strings: 'scary_strings',
  _growl: 'growl',
  _undo: 'undo',
  _whistle_down: 'whistle_down',
  _scary_cat: 'scary_cat',
  _intro_theme_new: 'intro_theme_new',
  _match: 'match',
  _night_scene: 'night_scene',
  _THUD: 'THUD',
  _click: 'click',
  _fling_pumpkin: 'fling_pumpkin',
  _door_squeak_cut: 'door_squeak_cut',
}